module.exports = __webpack_public_path__ + "img/DE02911.be8c2e01.png";